import { InjectionToken } from '@angular/core';
import { DataService } from './data-service.interface';

export const DATA_SERVICE = new InjectionToken<DataService>('DATA_SERVICE');
